/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { useTranslator } from '@jutro/locale';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLTooltipComponent } from 'ml-components-platform-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import metadata from './DriverTableComponent.metadata.json5';
import messages from './DriverTableComponent.messages';
import styles from './DriverTableComponent.module.scss';
import { Link } from '@jutro/router';
import appConfig from 'app-config';

import { IntlContext } from '@jutro/legacy/locale';

function DriverTableComponent(props) {
    const {
        list,
        hideAdd,
        hideEdit,
        hideRemove,
        hideInsure,
        onAdd,
        onEdit,
        onRemove,
        onInsure,
        addLabel,
        title,
        driverType,
        subtitle,
        helpTitle,
        helpDescription,
        showEndHr,
        isUmb,
        isGateway,
        titleTooltipHeader,
        titleTooltipContent,
        showPFM
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const maritalStatusTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('MaritalStatus');
    const genderTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('GenderType');
    const relToInsTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('InsuredRelationType_ML');
    const statusTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');
    const isQB = appConfig.portalCode === "QB"

    const {
        getRatedDriverType,
        getExcludedDriverType,
        getHouseholdDriverType
    } = MLDriverVehicleUtil();
    const ratedDriverType = getRatedDriverType();
    const excludedDriverType = getExcludedDriverType();
    const householdDriverType = getHouseholdDriverType();

    const isGatewayEmptyHhOrExcludedTable = () => {
        return isGateway && _.isEmpty(list) && (driverType === householdDriverType || driverType === excludedDriverType);
    }

    const isEmptyHhOrExcludedTable = () => {
        return !isGateway || isGatewayEmptyHhOrExcludedTable();
    }

    const getNameCell = (item, index, prop) => {
        return isGateway ? 
            (<strong>{_.get(item, prop.path, undefined)}</strong>)
            : _.get(item, prop.path, undefined);
    };

    const getCellVal = (item, index, prop) => {
        return _.get(item, prop.path, undefined);
    };

    const getDateCell = (items, index, prop) => {
        const dateVal = getCellVal(items, index, prop);

        if(isQB){
            return dateVal ? `**/**/${dateVal.year}` : undefined;
        }

        return dateVal ? intl.formatDate(
            new Date(dateVal.year, dateVal.month, dateVal.day), {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }) : undefined;
    };

    const getTypeList = (path) => {
        switch (path) {
            case 'gender':
            case 'contact.gender':
                return genderTypelist;
            case 'maritalStatus_ML':
            case 'contact.maritalStatus':
                return maritalStatusTypelist;
            case 'relationshipToInsured_ML':
            case 'relationshipToInsured':
                return relToInsTypelist;
            case 'status_ML':
            case 'driverStatusForAdding':
                return statusTypelist;
            default:
                return undefined;
        }
    };

    const getTcVal = (items, index, prop) => {
        const tcVal = getCellVal(items, index, prop);
        const typelist = getTypeList(prop.path);
        if (_.isUndefined(tcVal) || _.isUndefined(typelist)) {
            return undefined;
        }
        const { name } = typelist.getCode(tcVal);
        return translator({
            id: name,
            defaultMessages: name
        });
    };

    const getActionsCell = (item) => {
        if (_.isEmpty(item)) {
            return undefined;
        }
        return (
            <div className={styles.actionsCell}>
                {!hideEdit
                    ? <Link onClick={() => onEdit(item, driverType)}>{translator(messages.edit)}</Link>
                    : undefined}

                {!hideInsure
                    ? <Link onClick={() => onInsure(item, driverType)}>{translator(messages.insure)}</Link>
                    : undefined}

                {!hideRemove
                    ? <Link onClick={() => onRemove(item, driverType)}>{translator(messages.remove)}</Link>
                    : undefined}
            </div>
        );
    };

    const getWaivedCellVal = (item, index, prop) => {
        let waivedCellValue = '';
        const waivedValue = _.get(item, prop.path, undefined);
        const recievedValue = _.get(item, 'mvrOrderStatus_Ext', undefined);
        
        if (waivedValue && _.isEmpty(recievedValue)) {
            waivedCellValue =  'Waived'
        } else if (!_.isEmpty(recievedValue)) {
            waivedCellValue =  recievedValue
        }

        return waivedCellValue
    }

    const renderTitle = () => {
        return (_.isUndefined(subtitle) && !isGateway)
            || (isGateway && (_.isEmpty(list) || _.isUndefined(subtitle)))
            ? (
                <>
                    <h1 className={classNames(styles.tableTitle, 'section-header vertical-spacing-20')}>
                        {title}
                        {titleTooltipHeader && titleTooltipContent && (
                            <MLTooltipComponent
                                tooltipHeader={titleTooltipHeader}
                                tooltipContent={titleTooltipContent}
                            /> 
                        )}
                    </h1>
                </>
            )
            : (
                <div>
                    <h4 className={classNames(styles.tableTitle, 'section-header')}>
                        {title}
                        {titleTooltipHeader && titleTooltipContent && (
                            <MLTooltipComponent
                                tooltipHeader={titleTooltipHeader}
                                tooltipContent={titleTooltipContent}
                            /> 
                        )}
                    </h4>
                    <p className={isQB ? "body-copy vertical-spacing-20 text-primary-color" : "body-copy light vertical-spacing-20"}>
                        {subtitle}
                    </p>
                </div>
            );
    };

    const onAddDriver = useCallback(() => {
        onAdd(driverType, 'add');
    }, [onAdd, driverType]);


    const resolvers = {
        resolveCallbackMap: {
            getNameCell,
            getCellVal,
            getDateCell,
            getTcVal,
            getActionsCell,
            getWaivedCellVal,
            onAddDriver
        },
        resolveClassNameMap: styles
    };

    const getTitleId = (title) => {
        if(title === 'Excluded Drivers') {
            return 'excluded_drivers_table'
        }
        
        if (title === 'Household Members') {
            return 'household_members_table'
        }

        return 'drivers_table';
    }

    const overrides = {
        driversTable: {
            data: _.orderBy(list, 'publicID', 'asc'),
            renderTitle: renderTitle,
            className: isEmptyHhOrExcludedTable() ? styles.hideEmptyTableLine.concat(' row table') : 'row table',
            titleId: getTitleId(title)
        },
        addButton: {
            content: addLabel,
            visible: !hideAdd,
            type: (isGateway || isQB) ? 'outlined' : 'filled',
            className: isQB ? "secondaryButton widthSmall" : "mobileButton"
        },
        helpMsg: {
            tooltipContent: helpDescription,
            tooltipLabel: helpTitle,
            visible: (!_.isUndefined(helpTitle) && !_.isUndefined(helpDescription)) && !isGateway
        },
        nameCell: {
            path: isUmb ? 'contact.displayFullName_Ext' : 'person.displayFullName_Ext'
        },
        dobCell: {
            path: !isUmb ? 'dateOfBirth'
                : driverType === ratedDriverType ? 'contact.dateOfBirth' : 'contact.dateOfBirthForNonDriver'
        },
        genderCell: {
            path: isUmb ? 'contact.gender' : 'gender'
        },
        maritalStatusCell: {
            visible: (driverType === ratedDriverType || driverType === excludedDriverType),
            path: isUmb ? 'contact.maritalStatus' : 'maritalStatus_ML'
        },
        mvrStatusCell: {
            visible: driverType === ratedDriverType
        },
        relToInsCell: {
            visible: driverType === householdDriverType || driverType === excludedDriverType,
            path: isUmb ? 'relationshipToInsured' : 'relationshipToInsured_ML'
        },
        statusCell: {
            visible: driverType === householdDriverType || driverType === excludedDriverType,
            path: isUmb ? 'driverStatusForAdding' : 'status_ML'
        },
        pfmCell: {
            visible: isGateway && driverType === ratedDriverType && showPFM
        },
        umbNoInfoExists: {
            visible: isUmb && _.isEmpty(list)
        },
        gatewayNoDriversExists: {
            visible: isGatewayEmptyHhOrExcludedTable(),
            content: translator(messages.noDriversForQuote, {
                driverType: driverType === householdDriverType ? translator(messages.otherHouseholdMembers) : translator(messages.excludedDrivers)
            })
        },
        tableHr: {
            visible: showEndHr
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

DriverTableComponent.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hideAdd: PropTypes.bool,
    hideEdit: PropTypes.bool,
    hideRemove: PropTypes.bool,
    hideInsure: PropTypes.bool,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onReplace: PropTypes.func,
    onUndo: PropTypes.func,
    onInsure: PropTypes.func,
    addLabel: PropTypes.string,
    driverType: PropTypes.string,
    helpTitle: PropTypes.string,
    helpDescription: PropTypes.string,
    showEndHr: PropTypes.bool,
    isUmb: PropTypes.bool,
    isGateway: PropTypes.bool,
    titleTooltipHeader: PropTypes.string,
    titleTooltipContent: PropTypes.string
};

DriverTableComponent.defaultProps = {
    hideAdd: true,
    hideEdit: true,
    hideRemove: true,
    hideInsure: true,
    title: undefined,
    subtitle: undefined,
    onAdd: _.noop,
    onEdit: _.noop,
    onRemove: _.noop,
    onReplace: _.noop,
    onUndo: _.noop,
    onInsure: _.noop,
    addLabel: undefined,
    driverType: undefined,
    helpTitle: undefined,
    helpDescription: undefined,
    showEndHr: true,
    isUmb: false,
    isGateway: false
};

export default DriverTableComponent;
